const LOCALE = 'fr-FR';

/** "6.1 km" — one decimal, always shown (same rendering as the historical site). */
export function formatKm(metres: number): string {
    return `${(metres / 1000).toFixed(1)} km`;
}

/**
 * "2h", "2h15", "0h45": minutes rounded to the nearest quarter of an hour.
 * (The historical version printed "2h00" in some cases, this one never does.)
 */
export function formatDuration(hours: number): string {
    let h = Math.floor(hours);
    let quarter = Math.round(((hours - h) * 60) / 15) * 15;
    if (quarter === 60) {
        h += 1;
        quarter = 0;
    }
    return quarter === 0 ? `${h}h` : `${h}h${quarter.toString().padStart(2, '0')}`;
}

/** ["A"] → "A", ["A","B"] → "A et B", ["A","B","C"] → "A, B et C". */
export function formatList(items: string[]): string {
    if (items.length === 0) return '';
    if (items.length === 1) return items[0]!;
    return `${items.slice(0, -1).join(', ')} et ${items[items.length - 1]}`;
}

/** "06/10/2026 à 20:32:29" in the Réunion time zone. */
export function formatDateTime(iso: string, timeZone = 'Indian/Reunion'): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.toLocaleDateString(LOCALE, { timeZone })} à ${date.toLocaleTimeString(LOCALE, { timeZone })}`;
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
    return `${count} ${count > 1 ? plural : singular}`;
}
